import React from 'react';
import {Field, reduxForm, FieldArray} from 'redux-form';
import {connect} from 'react-redux';
import {FieldTxt, FieldSelect, FieldCheckbox} from '../../../components/Form/wh-field';
import FieldContents from '../../../components/Form/wh-contents';
import {Card, CardHeader, CardBody, CardFooter, Form, Alert, Button, Row, Col, ButtonGroup} from 'reactstrap';
import LaddaButton, {EXPAND_LEFT} from 'react-ladda';
import Loading from '../../../components/Loading';
import ApiConfig from '../../../constants/ApiConfig';



class FormEdit extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            defaultBlocOrder: true,
        };
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({
            defaultBlocOrder: !this.state.defaultBlocOrder
        });
    }


    render() {

        const {error, handleSubmit, pristine, reset, submitting, initialValues} = this.props;
        const {defaultBlocOrder} = this.state;


        return (

            <Form onSubmit={handleSubmit} className="form-vertical">

                <Row>
                    <Col sm="8" xs={12}>

                        <Field
                            label={false}
                            name="title"
                            component={FieldTxt}
                            type="text"
                            placeholder={'Saisir un titre'}
                            bsSize={'lg'}

                        />


                        <label>
                            changer l'ordre d'ajout des blocs :
                            <input
                                name="isGoing"
                                type="checkbox"
                                checked={this.state.isGoing}
                                onChange={this.handleInputChange} />
                        </label>

                       <FieldArray name="contents" component={FieldContents} defaultBlocOrder={defaultBlocOrder} />


                    </Col>
                    <Col sm="4" xs={12}>
                        <Card><Button color={'success'} block size={'lg'} onClick={this.props.show}>Voir</Button></Card>
                        <Card>
                            <CardHeader>
                                <i className="fa fa-align-justify"></i> Edition

                                <div className="card-actions">
                                     {/*<a href={`${ApiConfig.helpAdmin}/cms/pages.html`} target={'_blank'}><i className={'fa fa-question'}></i></a> */}
                                </div>

                            </CardHeader>

                            <CardBody>

                                <Field
                                    label="Résumé : "
                                    name="summary"
                                    component={FieldTxt}
                                    type="textarea"
                                />

                                <Field
                                    label="Icone class: "
                                    name="iconClass"
                                    component={FieldTxt}
                                    type="text"
                                />


                                <Field
                                    label="Position Menu: "
                                    name="menuScore"
                                    component={FieldTxt}
                                    type="text"
                                />


                                <Field
                                    label="Route: "
                                    name="route"
                                    component={FieldTxt}
                                    type="text"
                                />

                                <Field
                                    label="Slug: "
                                    name="slug"
                                    component={FieldTxt}
                                    type="text"
                                    disabled={true}
                                />

                                <Field
                                    label="Acheteur"
                                    name="buyer"
                                    component={FieldCheckbox}
                                    type="checkbox"
                                />

                                <Field
                                    label="TC"
                                    name="seller"
                                    component={FieldCheckbox}
                                    type="checkbox"
                                />


                                <Field
                                    label="Page site web"
                                    name="webSitePage"
                                    component={FieldCheckbox}
                                    type="checkbox"


                                />

                                <Field
                                    label="Page du menu ?"
                                    name="menu"
                                    component={FieldCheckbox}
                                    type="checkbox"
                                />

                                {/*
                                <Field
                                    label="Parent : "
                                    name="parent.id"
                                    component={FieldSelect}
                                    type="select"
                                    options={[{value : '@id/6', name : 'parent3'}, {value : '@id/9', name : 'parent2'}]}
                                />*/}

                                {error && <Alert color="danger"><div dangerouslySetInnerHTML={{__html: error}} /></Alert>}

                            </CardBody>

                            <CardFooter>

                                <LaddaButton
                                    className="btn btn-success btn-ladda"
                                    loading={submitting}
                                    data-style={EXPAND_LEFT}
                                    type={'submit'}
                                >
                                    <i className="fa fa-save"></i> Enregistrer </LaddaButton>

                            </CardFooter>

                        </Card>

                    </Col>
                </Row>



            </Form>

        );

    }

};


FormEdit = reduxForm({
    form: 'FormEditPage'
})(FormEdit);

export default FormEdit




// WEBPACK FOOTER //
// ./src/views/Cms/Pages/Form.js